<div class="image-loader-bus" fxFlexFill fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner *ngIf="loading || imageLoading" diameter="50"></mat-spinner>
    <img
        [hidden]="imageLoading"
        *ngIf="imageUrl && imageUrl !== '' && !loading"
        [class]="className"
        alt="image"
        [src]="imageUrl"
        (load)="onImageLoad()"
    />
    <div *ngIf="notFoundHide && !loading" [class]="className">{{ notFoundMessage }}</div>
</div>
